import { Container, Modal } from "react-bootstrap";
import PrimaryButton from "../../../util/Btns/PrimaryButton";

import styles from "./RemarksModal.module.scss";
import Close from "../../../Assets/close.svg";

const ReleaseNotesModal = ({
  showReleaseNotes,
  setShowReleaseNotes,
  build,
}) => {
  const handleClose = () => setShowReleaseNotes(false);

  const getText=(build)=>{
        if(build && build.releaseNote){
          return <div style={{ height: '300px',maxHeight: '300px',overflow: 'auto', width:'100%',}} dangerouslySetInnerHTML={{ __html: build?.releaseNote.split('\n').join('<br/>') }}></div>
        }
  }
  return (
    <>
      <Container>
        
        <Modal
          show={showReleaseNotes}
          onHide={handleClose}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Body >
            <div className={`${styles.body} release-modal`}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <h3>{build?.version} Release Notes</h3>
                <img
                  onClick={() => setShowReleaseNotes(false)}
                  src={Close}
                  height="14"
                  width="14"
                  alt="cross"
                  className="cursor-pointer"
                />
              </div>
              {/* <h4>What's new</h4>
              <ul>
                {build.releaseNotes.new.map((newFt) => (
                  <li key={newFt}>-{newFt}</li>
                ))}
              </ul>
              <h4>Bug Fixes</h4>
              <ul>
                {build.releaseNotes.bugFixes.map((fix) => (
                  <li key={fix}>-{fix}</li>
                ))}
              </ul> */}
                <>{getText(build)}</>
              {/* {build?.releaseNote.split('\n').join('<br/>')} */}
              <PrimaryButton onClick={() => setShowReleaseNotes(false)} style={{margin:"15px auto 0"}}>
                Ok
              </PrimaryButton>
              {/* </div> */}
            </div>
          </Modal.Body>
        </Modal>
      </Container>
      </>
  );
};

export default ReleaseNotesModal;
